/**
* This file was automatically generated by quicktype.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run command(npm run schemabuild) to regenerate this file.
*/
/**
 * 返回日历的权限状态
 */
export var OzoneCalendarStatus;
(function (OzoneCalendarStatus) {
    OzoneCalendarStatus["Authorized"] = "authorized";
    OzoneCalendarStatus["Denied"] = "denied";
    OzoneCalendarStatus["Restricted"] = "restricted";
    OzoneCalendarStatus["Undetermined"] = "undetermined";
})(OzoneCalendarStatus || (OzoneCalendarStatus = {}));
